export default "__VITE_ASSET__DOEaZfic__"